export default __webpack_public_path__ + "static/media/oficinasibs.9cbc98c6.png";